/// <reference path="Main.js" />
/// <reference path="Enumeration-vsdoc.js" />

function SepaVervollstaendigung(options) {
	$.extend(this, options);
	const self = this;
	self.init();
}

SepaVervollstaendigung.prototype = {
	InputNotifier: null,
	IbanUndBicGenerierenAjaxUrl: null,
	KontoNrBlzUndBicGenerierenAjaxUrl: null,
	AlleFelderUeberpruefenAjaxUrl: null,
	AuslaendischeIbanPruefenAjaxUrl: null,
	BicLaengePruefenAjaxUrl: null,
	KontoNrId: null,
	BlzId: null,
	IbanId: null,
	BicId: null,
	BicAuslandId: null,
	BanknameId: null,
	BitteIbanUeberpruefenMeldung: null,
	BitteBlzUeberpruefenMeldung: null,
	BitteKontoNrUeberpruefenMeldung: null,
	AuslaendischeIban: null,

	KontoNrFeld: null,
	BlzFeld: null,
	IbanFeld: null,
	BicFeld: null,
	BicAuslandFeld: null,
	ajaxComplete: true,
	waitingToBeFinished: function (wait100Ms, finishedFunc) {
		if (this.isFinished() || !wait100Ms) {
			finishedFunc();
			return;
		}
		JJK.AsyncMethod(
			this,
			function () {
				this.waitingToBeFinished(wait100Ms - 1, finishedFunc);
			},
			100
		);
	},
	isFinished: function () {
		return this.ajaxComplete;
	},
	setBic: function (value) {
		this.BicFeld.val(value);
		$('#BicHidden').val(value);
	},
	ibanUndBicGenerieren: function (userHasTyped) {
		const self = this;
		const kontoNr = this.KontoNrFeld.trimmedVal();
		const blz = this.BlzFeld.trimmedVal();
		const iban = this.IbanFeld.trimmedVal() !== undefined ? this.IbanFeld.trimmedVal().toUpperCase() : undefined;
		$.ajax({
			url: this.IbanUndBicGenerierenAjaxUrl,
			type: 'POST',
			data: { KontoNr: kontoNr, Blz: blz, Iban: iban },
			success: function (data) {
				if (!userHasTyped && self.iban !== undefined && data.Iban != null) {
					return;
				}
				if (data.Iban) {
					self.IbanFeld.val(data.Iban);
				}
				if (data.IbanFehler) {
					self.IbanFeld.error(data.IbanFehler);
				} else if (data.IbanMeldung) {
					self.IbanFeld.meldung(data.IbanMeldung);
				}
				self.setBic(data.Bic);
				if (userHasTyped) {
					self.KontoNrFeld.error(data.KontoNrFehler);
					self.BlzFeld.error(data.BlzFehler);
				}
				$(`#${self.BanknameId}`).html(data.Bankname != null ? data.Bankname : '');
			},
			complete: function () {
				self.ajaxComplete = true;
			},
		});
	},
	kontoNrBlzUndBicGenerieren: function (userHasTyped) {
		const self = this;
		const kontoNr = this.KontoNrFeld.trimmedVal();
		const blz = this.BlzFeld.trimmedVal();
		const iban = this.IbanFeld.trimmedVal() !== undefined ? this.IbanFeld.trimmedVal().toUpperCase() : undefined;
		if (typeof iban == 'undefined' || iban.substring(0, 2) === 'DE' || iban.substring(0, 2) === 'AT') {
			self.feldBicAuslandAktivieren(false);
			$.ajax({
				url: this.KontoNrBlzUndBicGenerierenAjaxUrl,
				type: 'POST',
				data: { KontoNr: kontoNr, Blz: blz, Iban: iban },
				success: function (data) {
					if (!userHasTyped && self.KontoNr !== undefined && data.KontoNr != null) {
						return;
					}
					if (data.KontoNr) {
						self.KontoNrFeld.val(data.KontoNr);
					}
					if (data.KontoNrFehler) {
						self.KontoNrFeld.error(data.KontoNrFehler, self.KontoNrFeld.Id);
					} else if (data.KontoNrMeldung) {
						self.KontoNrFeld.meldung(data.KontoNrMeldung, self.KontoNrFeld.Id);
					}
					if (data.Blz) {
						self.BlzFeld.val(data.Blz);
					}
					if (data.BlzFehler) {
						self.BlzFeld.error(data.BlzFehler, self.BlzFeld.Id);
					} else if (data.BlzMeldung) {
						self.BlzFeld.meldung(data.BlzMeldung, self.BlzFeld.Id);
					}
					self.setBic(data.Bic);
					if (userHasTyped) {
						self.IbanFeld.error(data.IbanFehler, self.IbanFeld.Id);
					}
					$(`#${self.BanknameId}`).html(data.Bankname != null ? data.Bankname : '');
				},
				complete: function () {
					self.ajaxComplete = true;
				},
			});
		} else {
			self.feldBicAuslandAktivieren(true);
			self.KontoNrFeld.val('');
			self.BlzFeld.val('');
			$.ajax({
				url: this.AuslaendischeIbanPruefenAjaxUrl,
				type: 'POST',
				data: { Iban: iban },
				success: function (data) {
					self.IbanFeld.error(data.IbanFehler, self.IbanFeld.Id);
				},
				complete: function () {
					self.ajaxComplete = true;
				},
			});
		}
	},
	feldBicAuslandAktivieren: function (ausland) {
		this.AuslaendischeIban = ausland;
		if (JJK.MakeBoolean(ausland)) {
			$(`#${this.BicId}`).hide();
			$(`#${this.BicId}`).closest('div[data-form-group-for-field]').hide();
			$(`#${this.BicAuslandId}`).show();
			$(`#${this.BicAuslandId}`).closest('div[data-form-group-for-field]').show();
			$(`#${this.BicAuslandId}`).trigger('focus');
		} else {
			$(`#${this.BicAuslandId}`).hide();
			$(`#${this.BicAuslandId}`).closest('div[data-form-group-for-field]').hide();
			$(`#${this.BicId}`).show();
			$(`#${this.BicId}`).closest('div[data-form-group-for-field]').show();
		}
	},
	init: function () {
		const self = this;
		self.feldBicAuslandAktivieren(self.AuslaendischeIban);
		this.KontoNrFeld = new this.InputNotifier({
			Id: this.KontoNrId,
			NotifyEveryBlur: true,
			Notifier: function (userHasTyped) {
				if (!JJK.MakeBoolean(self.AuslaendischeIban)) {
					self.ajaxComplete = false;
					JJK.AsyncMethod(self, JJK.Bind(self, self.ibanUndBicGenerieren, userHasTyped), 100);
				}
			},
		});
		this.BlzFeld = new this.InputNotifier({
			Id: this.BlzId,
			NotifyEveryBlur: true,
			Notifier: function (userHasTyped) {
				if (!JJK.MakeBoolean(self.AuslaendischeIban)) {
					self.ajaxComplete = false;
					JJK.AsyncMethod(self, JJK.Bind(self, self.ibanUndBicGenerieren, userHasTyped), 100);
				}
			},
		});
		this.IbanFeld = new this.InputNotifier({
			Id: this.IbanId,
			NotifyEveryBlur: true,
			Notifier: function (userHasTyped) {
				self.ajaxComplete = false;
				JJK.AsyncMethod(self, JJK.Bind(self, self.kontoNrBlzUndBicGenerieren, userHasTyped), 100);
			},
		});
		this.BicFeld = new this.InputNotifier({
			Id: this.BicId,
		});
		this.BicAuslandFeld = new this.InputNotifier({
			Id: self.BicAuslandId,
			NotifyEveryBlur: true,
			Notifier: function () {
				const value = $(`#${self.BicAuslandId}`).val() !== undefined ? $(`#${self.BicAuslandId}`).val().toUpperCase() : undefined;
				$('#BicHidden').val(value);
				self.ajaxComplete = false;
				JJK.AsyncMethod(self, JJK.Bind(self, self.bicPruefen), 100);
			},
		});
	},

	bicPruefen: function () {
		const bic = this.BicAuslandFeld.trimmedVal() !== undefined ? this.BicAuslandFeld.trimmedVal().toUpperCase() : undefined;
		const self = this;
		$.ajax({
			url: this.BicLaengePruefenAjaxUrl,
			type: 'POST',
			data: { Bic: bic },
			success: function (data) {
				self.BicAuslandFeld.error(data.BicFehler);
			},
			complete: function () {
				self.ajaxComplete = true;
			},
		});
	},

	alleFelderUeberpruefen: function () {
		const self = this;
		const kontoNr = this.KontoNrFeld.trimmedVal();
		const blz = this.BlzFeld.val();
		const iban = this.IbanFeld.trimmedVal() !== undefined ? this.IbanFeld.trimmedVal().toUpperCase() : undefined;
		$.post(this.AlleFelderUeberpruefenAjaxUrl, { KontoNr: kontoNr, Blz: blz, Iban: iban }, function (data) {
			self.KontoNrFeld.error(data.KontoNrMeldung, 'Kontonummer');
			self.BlzFeld.error(data.BlzMeldung, 'Bankleitzahl');
			self.IbanFeld.error(data.IbanMeldung, 'IBAN');
		});
	},
};
